import { render } from "./external.vue?vue&type=template&id=2c9f978c&scoped=true"
import script from "./external.vue?vue&type=script&lang=js"
export * from "./external.vue?vue&type=script&lang=js"

import "./external.vue?vue&type=style&index=0&id=2c9f978c&lang=scss&scoped=true"

import exportComponent from "/srv/sites/eservice.talronbatt.co.il/api/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c9f978c"]])

export default __exports__